<template>
    <div class="full flex wrap center">
        <div class="items full flex wrap center">
            <div class="item full flex wrap vcenter">
                <h4>
                    نام طرح:
                </h4>
                <span>
                    {{ data?.entity?.fid }}
                </span>
            </div>
            <div class="item full flex wrap vcenter">
                <h4>
                    نام سرمایه گذار:
                </h4>
                <span>
                    {{ data?.entity?.uid }}
                </span>
            </div>
            <div class="item full flex wrap vcenter">
                <h4>
                    مبلغ طرح:
                </h4>
                <span>
                    {{ data?.entity?.amount }} ریال
                </span>
            </div>
            <div class="item full flex wrap vcenter">
                <h4>
                    شماره پیگیری:
                </h4>
                <span>
                    {{ data?.entity?.referral_id }}
                </span>
            </div>
        </div>
        <div class="full document flex wrap center vcenter">
            <button @click.prevent="download()">دانلود گواهی شراکت الکترونیکی</button>
        </div>
        <div v-if="error" class="error full">
            <span class="full">خطا در دریافت گواهی شراکت رخ داد! لطفا مجددا تلاش کنید.</span>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Document',
    props: ['data'],
    inject: ['base'],
    components: {},
    computed: {
        id() {
            return this.data?.entity?.id
        }
    },
    data() {
        return {
            error: false
        }
    },
    watch: {
        id(newID, oldID) {
            this.error = false
        }
    },
    methods: {
        download() {
            this.$emit('onloading', true)
            this.base.API().postAsArrayBuffer(`Identities/File/ECertificate`, {
                data: this.data?.entity?.id
            }, (response) => {
                this.$emit('onloading', false)
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(new Blob([response.data]))
                link.setAttribute('download', `${this.data?.entity?.id}.pdf`)
                document.body.appendChild(link)
                link.click()

                this.$emit('onresult')
            }, (error) => {
                this.error = true
                this.$emit('onloading', false)
            })
        }
    }
}
</script>

<style scoped src="../../assets/css/components/dialogs/document.css"></style>
<style scoped src="../../assets/css/components/dialogs/document_dark.css"></style>